export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-tight text-foreground break-words">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1.5">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
